/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgRhombusBase = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 9 9" fill="none" {...props}>
    <path
      d="M0.354442 5.31905C0.233787 5.19825 0.166016 5.0345 0.166016 4.86376C0.166016 4.69302 0.233787 4.52927 0.354442 4.40847L3.7109 1.05236C3.77062 0.992504 3.84155 0.945012 3.91965 0.912609C3.99774 0.880205 4.08146 0.863525 4.16602 0.863525C4.25057 0.863525 4.33429 0.880205 4.41238 0.912609C4.49048 0.945012 4.56141 0.992504 4.62113 1.05236L7.97759 4.40847C8.09824 4.52927 8.16602 4.69302 8.16602 4.86376C8.16602 5.0345 8.09824 5.19825 7.97759 5.31905L4.62113 8.67516C4.50039 8.79579 4.33669 8.86355 4.16602 8.86355C3.99534 8.86355 3.83164 8.79579 3.7109 8.67516L0.354442 5.31905Z"
      fill="currentColor"
    />
  </svg>
);
const SvgRhombus = wrapIcon(SvgRhombusBase);
export default SvgRhombus;
